import { mdiHistory, mdiPaperclip, mdiFilterVariant } from "@mdi/js";
import Icon from "@mdi/react";
import debounce from "lodash.debounce";
import moment from "moment";
import { FunctionComponent, useCallback, useEffect, useState } from "react";
import LoadingWidget from "../../../context_providers/modal/loader";
import {
  ModalAlignment,
  ModalType,
} from "../../../context_providers/modal/modal_context";
import {
  useToast,
  ToastType,
} from "../../../context_providers/toast/toast_ctx";
import {
  fetchDelete,
  fetchGet,
  fetchPost,
  toQueryString,
} from "../../../service/api_client";
import SearchFieldWidget from "../../../ui/new_components/search_field";
import { UTCToLocalDate } from "../../../utils/date_util";
import { currencyFormat } from "../../../utils/currency_format";
import { urls } from "../../../utils/urls";
import {
  AttachmentModel,
  PurchaseOrderModelV2,
  PurchaseOrderStatus,
  getFileType,
  po_approval_status,
} from "../model/purchase_order_model";
import { file_dir } from "../../../utils/enums";
import DrawerModal, {
  DrawerModalLoaction,
} from "../../../ui/new_components/common/drawer_modal";
import ActionHistory from "../purchase_order_create/components/transfer_logs";
import Pagination from "../../../ui/new_components/common/pagination";
import { useHistory } from "react-router-dom";
import DrawerWidget from "../../../context_providers/modal/drawer_widget";
import AttachmentSectionV2 from "../purchase_order_create/components/attachment_widget_v2";
import {
  OptionsMultiFilter,
  PoCreatorMultiFilter,
  ProjectMultiFilter,
  VendorMultiFilter,
} from "../../../ui/new_components/entity_selects/EntityMultiFilters";
import { POListFilter } from "../purchase_order_create/models/enums";
import { round } from "lodash";
import { formatAmountWithCommas } from "../../../ui/pages/content_panel/utils/helpers";
import {
  ResponsiveListShell,
  FilterSheet,
  DateRangeFilter,
  MobileRecordCard,
  MobileRecordCardList,
  StatusBadge,
  EmptyState,
} from "../../../ui/new_components/common/responsive";
import "../../../styles/responsive_shrink.css";

const defaultFilter = (): POListFilter => {
  return {
    page: 1,
    count: 100,
    all: false,
  };
};
interface PurchaseOrderApprovalListScreenProps {}

const PurchaseOrderApprovalListScreen: FunctionComponent<
  PurchaseOrderApprovalListScreenProps
> = () => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order`;
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [ShowHistory, setShowHistory] = useState<any>();
  const [ShowHistory1, setShowHistory1] = useState<any>();
  const [total, setTotal] = useState(0);
  const [data, setData] = useState<PurchaseOrderModelV2[]>([]);
  const history = useHistory();
  const [filterCollaped, setFilterCollapsed] = useState<boolean>(false);
  const tempFilter = localStorage.getItem("po_approval_filter");
  const [filter, setFilter] = useState<POListFilter>(
    // Drop old free-text/single-value filters no longer in the UI so a stale
    // saved value can't silently narrow the list.
    tempFilter
      ? {
          ...JSON.parse(tempFilter),
          project_name: undefined,
          party_id: undefined,
          party_name: undefined,
          created_by_name: undefined,
        }
      : defaultFilter,
  );
  const fetchData = async (prop: POListFilter) => {
    setLoading(true);
    try {
      const res = await fetchGet(
        url + toQueryString({ ...prop, approval: true }),
      );

      if (res.success) {
        setData(res.data.data);
        if (res.data.metadata) {
          setTotal(res.data.metadata.total);
        }
      } else {
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
    }
    setLoading(false);
  };
  const debouncedHandler = useCallback(
    debounce((prop: POListFilter) => {
      if (prop) fetchData(prop);
      else setData([]);
    }, 100),
    [],
  );

  useEffect(() => {
    localStorage.setItem("po_approval_filter", JSON.stringify(filter));
  }, [filter]);

  useEffect(() => {
    debouncedHandler(filter);
  }, [filter]);
  const [showAttachment, setShowAttachment] = useState<PurchaseOrderModelV2>();
  const [, setAttachmentKey] = useState(Math.random() * 10000);

  const uploadFile = async ({
    file,
    category,
    removeSelectedFile,
    setShowUpload,
  }: {
    file: File;
    category: string;
    removeSelectedFile: () => void;
    setShowUpload: (v: boolean) => void;
  }) => {
    try {
      if (!file || !category) {
        showToast({
          type: ToastType.warning,
          text: "Please select file and category",
        });
        return;
      }
      setLoading(true);
      const { name, type } = file;
      const create_url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order/${showAttachment?.id}/attachment`;
      const get_signed_urls = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/signed-url`;
      const query = {
        mimetype: type,
        extension: name.split(".").pop(),
        dir: file_dir.pocuremnt_attachments,
      };
      const res = await fetchGet(get_signed_urls + toQueryString(query));
      if (res.success) {
        const { url } = res.data;

        const attachment: AttachmentModel = {
          id: "",
          category,
          type: getFileType(type),
          url,
        };
        const create_res = await fetchPost(create_url, attachment);

        if (create_res.success) {
          showToast({
            type: ToastType.success,
            text: create_res.message,
          });
          setData((o) => [
            ...o.map((f) => {
              if (f.id === showAttachment)
                return {
                  ...f,
                  attachments: [...(f.attachments || []), create_res.data],
                };
              return f;
            }),
          ]);

          removeSelectedFile();
          setShowUpload(false);
          setAttachmentKey(Math.random() * 1000);
        }
      }
      setLoading(false);
    } catch (error: any) {
      showToast({
        type: ToastType.error,
        text: error.message,
      });
      setLoading(false);
    }
  };
  const deleteFile = async (att: AttachmentModel) => {
    try {
      if (!window.confirm("Are your sure to delete ?")) return;
      if (!att) {
        showToast({
          type: ToastType.warning,
          text: "Please select file",
        });
        return;
      }
      setLoading(true);
      const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order/${showAttachment?.id}/attachment/${att.id}`;

      const res = await fetchDelete(url);

      if (res.success) {
        showToast({
          type: ToastType.success,
          text: res.message,
        });
        setData((o) => [
          ...o.map((f) => {
            if (f.id == showAttachment) {
              f.attachments = f.attachments.filter((f) => f.id !== att.id);
            }
            return f;
          }),
        ]);

        setAttachmentKey(Math.random() * 1000);
      }
      setLoading(false);
    } catch (error: any) {
      showToast({
        type: ToastType.error,
        text: error.message,
      });
      setLoading(false);
    }
  };

  const onSelectAttchment = (d: AttachmentModel) => {
    window.open(d.url, "_blank");
  };

  const clearLocalStore = () => {
    // Remove from localStorage
    localStorage.removeItem("po_approval_filter");

    // Reset filter state
    const defaultFilterObj = defaultFilter();
    setFilter(defaultFilterObj);

    // Trigger UI updates and fetch
    debouncedHandler(defaultFilterObj);
    fetchData(defaultFilterObj);
  };
  return (
    <>
      {ShowHistory && (
        <DrawerModal
          id="po_approval_list_history_drawer"
          location={DrawerModalLoaction.right}
          show={ShowHistory !== undefined}
          onClose={() => setShowHistory(undefined)}
          title="History"
        >
          <ActionHistory po_no={ShowHistory} data={ShowHistory1} />
        </DrawerModal>
      )}
      {showAttachment && (
        <DrawerWidget
          id="po_approval_list_attachments_drawer"
          data={{
            id: 1,
            title: "Attchments",
            type: ModalType.drawer,
            alignment: ModalAlignment.right,
            container: (
              <AttachmentSectionV2
                // key={attachmentKey}
                poNo={showAttachment}
                attachments={showAttachment.attachments}
                onSubmit={uploadFile}
                onDelete={deleteFile}
                onSelect={onSelectAttchment}
              />
            ),
          }}
          onClose={function (): void {
            setShowAttachment(undefined);
          }}
        ></DrawerWidget>
      )}
      <ResponsiveListShell
        title="Purchase Order Approvals"
        count={total}
        onRefresh={() => debouncedHandler(filter)}
        search={
          <div id="po_approval_list_search">
            <SearchFieldWidget
              placeholder="Search PO ID"
              defaulValue={filter.po_no ?? ""}
              onClear={() => setFilter((p) => ({ ...p, po_no: "" }))}
              onSubmit={(value) => setFilter((p) => ({ ...p, po_no: value }))}
            />
          </div>
        }
        actions={
          <button
            id="po_approval_list_clear_filter_btn"
            className="flex gap-1 items-center cursor-pointer rounded p-1 bg-myPrimaryColor hover:scale-105 duration-200 text-xs text-white transform"
            onClick={() => clearLocalStore()}
          >
            Clear Filter
          </button>
        }
        filterToggle={
          <div className="flex gap-2 items-center">
            <h6 className="font-normal text-xs">Filters</h6>
            <div
              id="po_approval_list_filter_toggle_btn"
              onClick={() => setFilterCollapsed((v) => !v)}
              className="flex items-center justify-center bg-gray-200 p-1 rounded-full hover:bg-gray-800 hover:text-white cursor-pointer"
            >
              <Icon path={mdiFilterVariant} className="w-4 h-4" />
            </div>
          </div>
        }
      >
        <FilterSheet
          show={filterCollaped}
          onClose={() => setFilterCollapsed(false)}
          onApply={() => setFilterCollapsed(false)}
          onReset={() => setFilter(defaultFilter())}
          gridClassName="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-3 gap-y-2 items-start"
        >
          <div id="po_approval_list_order_date_filter">
            <label>Order Date</label>
            <DateRangeFilter
              compact
              showChips={false}
              fromDate={
                filter.fromDate
                  ? moment(filter.fromDate).format("YYYY-MM-DD")
                  : undefined
              }
              toDate={
                filter.toDate
                  ? moment(filter.toDate).format("YYYY-MM-DD")
                  : undefined
              }
              onFromChange={(v) => {
                if (!v) {
                  setFilter((o) => ({ ...o, fromDate: undefined }));
                  return;
                }
                const now = UTCToLocalDate(v)!;
                const fromDate = new Date(new Date(now).setHours(0, 0, 0, 0));
                setFilter((o) => ({ ...o, fromDate }));
              }}
              onToChange={(v) => {
                if (!v) {
                  setFilter((o) => ({ ...o, toDate: undefined }));
                  return;
                }
                const now = UTCToLocalDate(v)!;
                const toDate = new Date(
                  new Date(now).setHours(23, 59, 59, 999),
                );
                setFilter((o) => ({ ...o, toDate }));
              }}
            />
          </div>
          <div id="po_approval_list_vendor_filter">
            <label>Vendor</label>
            <VendorMultiFilter
              values={filter.vendor_id}
              onChange={(vendor_id) =>
                setFilter((o) => ({ ...o, page: 1, vendor_id }))
              }
            />
          </div>
          <div id="po_approval_list_created_by_filter">
            <label>Created By</label>
            <PoCreatorMultiFilter
              values={filter.created_by}
              onChange={(created_by) =>
                setFilter((o) => ({ ...o, page: 1, created_by }))
              }
            />
          </div>
          <div id="po_approval_list_project_filter">
            <label>Project</label>
            <ProjectMultiFilter
              values={filter.project_id}
              onChange={(project_id) =>
                setFilter((o) => ({ ...o, page: 1, project_id }))
              }
            />
          </div>
          <div id="po_approval_list_po_status_filter">
            <label>PO Status</label>
            <OptionsMultiFilter
              placeholder="Select PO status"
              options={Object.values(PurchaseOrderStatus)}
              values={filter.po_status}
              onChange={(po_status) =>
                setFilter((o) => ({ ...o, page: 1, po_status }))
              }
            />
          </div>
          <div id="po_approval_list_approval_status_filter">
            <label>Approval Status</label>
            <OptionsMultiFilter
              placeholder="Select approval status"
              options={Object.values(po_approval_status)}
              values={filter.approval_status}
              onChange={(approval_status) =>
                setFilter((o) => ({ ...o, page: 1, approval_status }))
              }
            />
          </div>
          <div id="po_approval_list_last_approved_filter">
            <label>Last Approved</label>
            <DateRangeFilter
              compact
              showChips={false}
              fromLabel="Last Approved From"
              toLabel="Last Approved To"
              fromDate={
                filter.last_approved_date
                  ? moment(filter.last_approved_date).format("YYYY-MM-DD")
                  : undefined
              }
              toDate={
                filter.to_last_approved_date
                  ? moment(filter.to_last_approved_date).format("YYYY-MM-DD")
                  : undefined
              }
              onFromChange={(v) =>
                setFilter({
                  ...filter,
                  last_approved_date: v
                    ? new Date(new Date(v).setHours(0, 0, 0, 0))
                    : undefined,
                })
              }
              onToChange={(v) =>
                setFilter({
                  ...filter,
                  to_last_approved_date: v
                    ? new Date(new Date(v).setHours(0, 0, 0, 0))
                    : undefined,
                })
              }
            />
          </div>
        </FilterSheet>

        <div
          className="hidden md:block my-2 border overflow-auto"
          style={{ height: "80%" }}
        >
          <table
            id="po_approval_list_table"
            className="w-full text-xs divide-y divide-gray-200 relative"
          >
            <thead className="text-xs py-2 sticky -top-1 bg-white z-10">
              <tr className="border">
                <th className="px-2 py-2">Actions</th>
                <th className="px-3 py-3 whitespace-nowrap text-left">Po No</th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Created At
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Created By Name
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Project Name
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Vendor Name
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Bill to
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Ship to
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">CGST</th>
                <th className="px-3 py-3 whitespace-nowrap text-left">SGST</th>
                <th className="px-3 py-3 whitespace-nowrap text-left">IGST</th>
                <th className="px-3 py-3 whitespace-nowrap text-right">
                  Currency
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-right">
                  Total Amount(USD)
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-right">
                  Total Amount(INR)
                </th>

                <th className="px-3 py-3 whitespace-nowrap text-left">Paid</th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Balance
                </th>

                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Approval Status
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  First Approved By
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Last Approved By
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Last Approved At
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  PO Status
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Inward Status
                </th>
                <th className="px-3 py-3 whitespace-nowrap text-left">
                  Attachmnets
                </th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((item, i) => (
                  <tr
                    id={`po_approval_list_row_${item.po_no}`}
                    className="border text-center"
                    key={i}
                  >
                    <td>
                      <div className="flex gap-2 justify-center">
                        <div
                          id={`po_approval_list_row_${item.po_no}_history_btn`}
                          className="cursor-pointer"
                          onClick={() => setShowHistory(item.po_no)}
                        >
                          <Icon path={mdiHistory} size="16" />
                        </div>
                      </div>
                    </td>
                    <td
                      id={`po_approval_list_row_${item.po_no}_link`}
                      className="px-3 py-3 whitespace-nowrap text-left cursor-pointer text-blue-600 hover:underline"
                      role="button"
                      onClick={() => {
                        history.push(
                          urls.purchase_order + "/approval/" + item.id,
                        );
                      }}
                    >
                      {item.po_no}
                      {item.version ? `-${item.version}` : ""}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap text-left">
                      {moment(item.created_at).format("DD-MM-YYYY") ?? "--"}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap text-left">
                      {item.created_by_name ?? "--"}
                    </td>

                    <td className="px-3 py-3 whitespace-nowrap text-left">
                      {item.items[0]?.project?.name ?? "--"}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap text-left">
                      {item.party?.name ?? "--"}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap text-left">
                      {item.bill_to?.gst_number ?? "--"}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap text-left">
                      {item.warehouse.name ?? "--"}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap text-left">
                      {item.cgst ?? "--"}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap text-left">
                      {item.sgst ?? "--"}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap text-left">
                      {item.igst ?? "--"}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap text-left">
                      {item.vendor_currency.short_name ?? "--"}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap text-right">
                      {item.vendor_currency.short_name === "USD"
                        ? `${item.vendor_currency.symbol}${currencyFormat(
                            formatAmountWithCommas(round(item.total, 2)),
                          )} `
                        : `--`}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap text-right">
                      {item.vendor_currency.short_name === "USD"
                        ? (formatAmountWithCommas(
                            round(item.total, 2) * item.vendor_currency_to_inr,
                          ) ?? "--")
                        : (formatAmountWithCommas(round(item.total, 2)) ??
                          "--")}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap text-right">
                      {formatAmountWithCommas(item.paid)}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap text-right">
                      {item.vendor_currency.short_name === "USD" &&
                      item.total > 0
                        ? formatAmountWithCommas(
                            round(
                              item.total * item.vendor_currency_to_inr -
                                item.paid,
                              2,
                            ),
                          )
                        : formatAmountWithCommas(
                            round(item.total - item.paid, 2),
                          )}
                    </td>

                    {/* Approval Status */}
                    <td className="px-3 py-3 whitespace-nowrap text-left">
                      {item.approval_status ?? "--"}
                    </td>
                    {/* First Approval By Status */}
                    <td className="px-3 py-3 whitespace-nowrap text-left">
                      {item.approvals?.[0]?.approved_by_name ?? "--"}
                    </td>
                    {/* Last Approval By Status */}
                    <td className="px-3 py-3 whitespace-nowrap text-left">
                      {item.approvals?.[item.approvals.length - 1]
                        ?.approved_by_name ?? "--"}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap text-left">
                      {(item.approvals ?? []).length > 0
                        ? moment(item?.approvals?.[0]?.approved_at).format(
                            "DD-MM-YYYY",
                          )
                        : item.approval_status === "Approved"
                          ? item.updated_at
                            ? moment(item.updated_at).format("DD-MM-YYYY")
                            : item.created_at
                              ? moment(item.created_at).format("DD-MM-YYYY")
                              : "--"
                          : "--"}
                    </td>
                    {/* Status */}
                    <td className="px-3 py-3 whitespace-nowrap text-left">
                      {item.status ?? "--"}
                    </td>
                    {/* Inward Status */}
                    <td className="px-3 py-3 whitespace-nowrap text-left">
                      {item.total_received_qty === 0
                        ? "Pending"
                        : (item.total_po_qty ?? 0) >
                            (item.total_received_qty ?? 0)
                          ? "Partial"
                          : "Completed"}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap text-left">
                      {" "}
                      <button
                        id={`po_approval_list_row_${item.po_no}_attachments_btn`}
                        onClick={() => setShowAttachment(item)}
                        className="relative text-sm font-semibold text-blue-400 hover:text-blue-500 whitespace-nowrap sticky-field  flex items-center gap-1 px-2 h-full w-full"
                      >
                        View
                        <div>({item?.attachments?.length})</div>
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={22}>
                    <EmptyState title="No purchase orders found" />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {data.length > 0 ? (
          <MobileRecordCardList>
            {data.map((item, i) => {
              const inwardStatus =
                item.total_received_qty === 0
                  ? "Pending"
                  : (item.total_po_qty ?? 0) > (item.total_received_qty ?? 0)
                    ? "Partial"
                    : "Completed";
              const totalInr =
                item.vendor_currency.short_name === "USD"
                  ? formatAmountWithCommas(
                      round(item.total, 2) * item.vendor_currency_to_inr,
                    )
                  : formatAmountWithCommas(round(item.total, 2));
              const balance =
                item.vendor_currency.short_name === "USD" && item.total > 0
                  ? formatAmountWithCommas(
                      round(
                        item.total * item.vendor_currency_to_inr - item.paid,
                        2,
                      ),
                    )
                  : formatAmountWithCommas(round(item.total - item.paid, 2));
              return (
                <MobileRecordCard
                  id={`po_approval_list_row_mobile_${item.po_no}`}
                  key={i}
                  title={
                    <span
                      onClick={() =>
                        history.push(
                          urls.purchase_order + "/approval/" + item.id,
                        )
                      }
                    >
                      #{item.po_no}
                      {item.version ? `-${item.version}` : ""}
                    </span>
                  }
                  status={
                    <StatusBadge status={item.approval_status} kind="generic" />
                  }
                  subStatus={
                    <div className="flex flex-wrap gap-2">
                      <StatusBadge status={item.status} kind="generic" />
                      <StatusBadge status={inwardStatus} kind="generic" />
                    </div>
                  }
                  fields={[
                    {
                      label: "Created At",
                      value: item.created_at
                        ? moment(item.created_at).format("DD-MM-YYYY")
                        : "--",
                    },
                    {
                      label: "Created By",
                      value: item.created_by_name ?? "--",
                    },
                    {
                      label: "Project",
                      value: item.items[0]?.project?.name ?? "--",
                    },
                    { label: "Vendor", value: item.party?.name ?? "--" },
                    { label: "Ship to", value: item.warehouse?.name ?? "--" },
                    {
                      label: "Currency",
                      value: item.vendor_currency.short_name ?? "--",
                    },
                    { label: "Total (INR)", value: totalInr },
                    { label: "Paid", value: formatAmountWithCommas(item.paid) },
                    { label: "Balance", value: balance },
                  ]}
                  actions={[
                    {
                      icon: mdiHistory,
                      title: "History",
                      onClick: () => setShowHistory(item.po_no),
                    },
                    {
                      icon: mdiPaperclip,
                      title: `Attachments (${item?.attachments?.length ?? 0})`,
                      onClick: () => setShowAttachment(item),
                    },
                  ]}
                />
              );
            })}
          </MobileRecordCardList>
        ) : (
          <div className="md:hidden">
            <EmptyState title="No purchase orders found" />
          </div>
        )}

        <div id="po_approval_list_pagination" className="mt-3">
          <Pagination
            itemCount={filter.count}
            page={filter.page}
            total={total}
            count={filter.count}
            onChange={(page) => setFilter((o) => ({ ...o, page }))}
          />
        </div>
      </ResponsiveListShell>

      {loading && <LoadingWidget></LoadingWidget>}
    </>
  );
};

export default PurchaseOrderApprovalListScreen;
